'use client'

import type { ReactNode } from 'react'

import { useDialogContext } from '@morpho-org/ui-v6/contexts'
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui'
import { Question } from '@repo/ui/icons'

import BorrowDialogContentClient from '@/components/common/Dialog/BorrowDialog/BorrowDialogContentClient'
import { trackHowItWorksOpened } from '@/lib/analytics/client/trackers/how-it-works'

interface MarketSectionHeroProps {
  metricSlot?: ReactNode
}

export default function MarketSectionHero({ metricSlot }: MarketSectionHeroProps) {
  const { toggleDialog } = useDialogContext()

  const handleHelpClick = () => {
    trackHowItWorksOpened({ page: 'markets', source: 'hero' })
    toggleDialog(<BorrowDialogContentClient />, {
      closable: true,
      fullSize: true
    })
  }

  return (
    <div className="gap-xs flex w-full flex-wrap items-center justify-between">
      <div className="gap-2xs flex flex-col">
        <div className="gap-xs flex items-center">
          <h1 className="text-title-sm">Variable Rate Markets</h1>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="iconSm"
                aria-label="How it works"
                onClick={handleHelpClick}
              >
                <Question />
              </Button>
            </TooltipTrigger>
            <TooltipContent>How it works</TooltipContent>
          </Tooltip>
        </div>
        <p className="text-secondary-foreground text-sm">
          Lend and borrow at variable rates in Morpho Markets.
        </p>
      </div>
      {metricSlot}
    </div>
  )
}
